function escapeHtml(value) {
    return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

function buildOptionAccordionHtml(title, selectedType, options) {
    if (!options || typeof options !== "object") {
        return "";
    }

    const entries = Object.entries(options);

    if (entries.length === 0) {
        return "";
    }

    const selectedEntry = entries.find(function ([value]) {
        return value === selectedType;
    });
    const selectedLabel = selectedEntry ? selectedEntry[1] : "—";

    let itemsHtml = "";

    entries.forEach(function ([value, label]) {
        const isSelected = selectedType === value;
        const itemClass = isSelected
            ? "staff-option-accordion__item is-selected"
            : "staff-option-accordion__item";
        const markHtml = isSelected
            ? '<span class="staff-option-accordion__mark" aria-hidden="true"><i class="fas fa-check"></i></span>'
            : '<span class="staff-option-accordion__mark" aria-hidden="true"></span>';

        itemsHtml += `<li class="${itemClass}">
            ${markHtml}
            <span class="staff-option-accordion__label">${escapeHtml(label)}</span>
        </li>`;
    });

    return `<details class="staff-option-accordion">
        <summary class="staff-option-accordion__summary">
            <span class="staff-option-accordion__heading">${escapeHtml(title)}</span>
            <span class="staff-option-accordion__value">${escapeHtml(selectedLabel)}</span>
            <i class="fas fa-chevron-down staff-option-accordion__icon" aria-hidden="true"></i>
        </summary>
        <ul class="staff-option-accordion__list">${itemsHtml}</ul>
    </details>`;
}

function buildStaffMemberInfoHtml(data, optionSets) {
    const sets = optionSets || {};
    const attendanceTypeOptions = sets.attendanceTypeOptions || {};
    const reimbursementOptions = sets.reimbursementOptions || {};

    const lines = [];
    const name = [data.first_name, data.last_name].filter(Boolean).join(" ").trim();

    if (name) {
        lines.push(`<div class="staff-member-info__name">${escapeHtml(name)}</div>`);
    }

    if (data.email) {
        lines.push(`<div class="staff-member-info__line">${escapeHtml(data.email)}</div>`);
    }

    const businessUnit = [data.business_unit, data.specify_business_unit]
        .filter(Boolean)
        .join(" ")
        .trim();

    if (businessUnit) {
        lines.push(`<div class="staff-member-info__line">${escapeHtml(businessUnit)}</div>`);
    }

    const attendanceTypeHtml = buildOptionAccordionHtml(
        "ประเภทการเข้าร่วมการประชุม",
        data.attendance_type || null,
        attendanceTypeOptions
    );

    if (attendanceTypeHtml) {
        lines.push(attendanceTypeHtml);
    }

    const reimbursementHtml = buildOptionAccordionHtml(
        "การเบิกจ่าย",
        data.reimbursement_type || null,
        reimbursementOptions
    );

    if (reimbursementHtml) {
        lines.push(reimbursementHtml);
    }

    if (data.headphone_info) {
        lines.push(
            `<div class="staff-member-info__line staff-member-info__line--muted">รหัสหูฟัง: ${escapeHtml(data.headphone_info)}</div>`
        );
    }

    return `<div class="staff-member-info">${lines.join("")}</div>`;
}

module.exports = {
    escapeHtml,
    buildOptionAccordionHtml,
    buildStaffMemberInfoHtml,
};
